import axiosInstance from './api/axios';

export const offersService = {
  list: async () => (await axiosInstance.get('/offers')).data,
  create: async (paymentMethodGroupId: string, description: string) => (await axiosInstance.post('/offers', { payment_method_group_id: paymentMethodGroupId, description: description || null })).data,
  update: async (id: string, description: string) => (await axiosInstance.put(`/offers/${id}`, { description: description || null })).data,
  remove: async (id: string) => axiosInstance.delete(`/offers/${id}`),
  export: async (format: 'csv' | 'xlsx') => {
    const response = await axiosInstance.get('/offers/export/file', { params: { format }, responseType: 'blob' });
    const url = URL.createObjectURL(response.data); const link = document.createElement('a');
    link.href = url; link.download = `offers.${format}`; link.click(); URL.revokeObjectURL(url);
  },
};
